// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const limestoneOutcrop = defineModel({
  id: "limestone-outcrop",
  batchId: "future",
  name: "Limestone outcrop",
  tags: ["scenery","limestone","outcrop","low-poly","age-of-mcp","future"],
  summary: "Blocky limestone. Burnt to lime for mortar, used as smelting flux, in glass and as whitewash — a four-way workhorse.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.42,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.34, 0.26, 0.3), color: "#d8d2c0", position: [-0.08, 0.15, 0.02], rotation: [0.05, 0.3, 0.04] },
      { geometry: new THREE.BoxGeometry(0.26, 0.34, 0.24), color: "#e6e1d2", position: [0.16, 0.19, -0.04], rotation: [0.02, -0.5, -0.06] },
      { geometry: new THREE.BoxGeometry(0.2, 0.18, 0.2), color: "#bcb6a3", position: [0.02, 0.32, 0.1], rotation: [0.1, 0.8, 0.05] },
      { geometry: new THREE.IcosahedronGeometry(0.07, 0), color: "#e6e1d2", position: [0.18, 0.05, 0.1], rotation: [0.3, 0.5, 0.2] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#d8d2c0", position: [-0.28, 0.04, -0.12], rotation: [0.2, 1, 0.3] },
    ],
  animations: [],
});
